import type { NavigationName } from '@/types/NavigationName';
import { HORIZONTAL, VERTICAL } from '../enums/NavigationNameDirections';

export const NavigationNames: NavigationName[] = [
  {
    value: 'create-password',
    title: 'Create a Password',
    direction: VERTICAL,
  },
  {
    value: 'reset-password',
    title: 'Reset your password',
    direction: VERTICAL,
  },
  {
    value: 'verify',
    title: 'Verify Email',
    direction: HORIZONTAL,
  },

  {
    value: 'account-settings',
    title: 'Account Settings',
    direction: HORIZONTAL,
  },
  {
    value: 'update-password',
    title: 'Update Password',
    direction: VERTICAL,
  },
  {
    value: 'delete-account',
    title: 'Delete Account',
    direction: VERTICAL,
  },
  {
    value: 'company-profile',
    title: 'Company Profile',
    direction: VERTICAL,
  },
  {
    value: 'help-centre',
    title: 'Help Centre',
    direction: HORIZONTAL,
  },
  {
    value: 'report-a-problem',
    title: 'Report a Problem',
    direction: HORIZONTAL,
  },
  {
    value: 'about',
    title: 'About',
    direction: HORIZONTAL,
  },
  {
    value: 'terms-of-service',
    title: 'Terms of Service',
    direction: HORIZONTAL,
  },
  {
    value: 'privacy-policy',
    title: 'Privacy Policy',
    direction: HORIZONTAL,
  },
];
